import { render, staticRenderFns } from "./NutritionDetail.vue?vue&type=template&id=1ba20644&scoped=true&"
import script from "./NutritionDetail.vue?vue&type=script&lang=js&"
export * from "./NutritionDetail.vue?vue&type=script&lang=js&"
import style0 from "./NutritionDetail.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./NutritionDetail.vue?vue&type=style&index=1&id=1ba20644&scoped=true&lang=scss&"
import style2 from "./NutritionDetail.vue?vue&type=style&index=2&lang=css&"
import style3 from "./NutritionDetail.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba20644",
  null
  
)

export default component.exports